// src/crypto/aead.ts
// XChaCha20-Poly1305 包装。统一密文格式：[ 24B nonce | N B ciphertext | 16B tag ]。
// 总开销固定 +40B。
import { xchacha20poly1305 } from "@noble/ciphers/chacha";
import { randomBytes } from "@noble/ciphers/webcrypto";
import { AEAD } from "./params";
export function aeadSeal(key, plaintext, aad) {
    if (key.length !== AEAD.keyLen)
        throw new Error("aeadSeal: key must be 32B");
    const nonce = randomBytes(AEAD.nonceLen);
    const ctTag = xchacha20poly1305(key, nonce, aad).encrypt(plaintext);
    // ctTag 末尾自带 16B Poly1305 tag
    const out = new Uint8Array(AEAD.nonceLen + ctTag.length);
    out.set(nonce, 0);
    out.set(ctTag, AEAD.nonceLen);
    return { bytes: out };
}
export function aeadOpen(key, blob, aad) {
    if (key.length !== AEAD.keyLen)
        throw new Error("aeadOpen: key must be 32B");
    if (blob.length < AEAD.nonceLen + AEAD.tagLen) {
        throw new Error("aeadOpen: blob too short");
    }
    const nonce = blob.subarray(0, AEAD.nonceLen);
    const ctTag = blob.subarray(AEAD.nonceLen);
    // 解密失败会抛 InvalidTagError —— 让 caller 处理
    return xchacha20poly1305(key, nonce, aad).decrypt(ctTag);
}
/** 仅用于"内存敏感数据"清零；JS GC 无法保证彻底，但 best-effort。 */
export function zeroize(bytes) {
    if (bytes)
        bytes.fill(0);
}
